import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "buildpack-command-line-interface"
    }}>{`Buildpack Command Line Interface`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`buildpack`}</inlineCode>{` command is a command line toolkit for managing different pieces of your storefront project using subcommands.`}</p>
    <h2 {...{
      "id": "running-the-buildpack-command"
    }}>{`Running the `}<inlineCode parentName="h2">{`buildpack`}</inlineCode>{` command`}</h2>
    <p>{`You can use the `}<inlineCode parentName="p">{`buildpack`}</inlineCode>{` command as a project dependency or directly using `}<inlineCode parentName="p">{`npx`}</inlineCode>{`.`}</p>
    <h3 {...{
      "id": "as-a-project-dependency"
    }}>{`As a project dependency`}</h3>
    <p>{`A project with the `}<inlineCode parentName="p">{`@magento/pwa-buildpack`}</inlineCode>{` dependency installed can use the `}<inlineCode parentName="p">{`buildpack`}</inlineCode>{` command in its NPM scripts:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"scripts": {
  "load-env": "buildpack load-env ."
}
`}</code></pre>
    <p>{`With this example, you can run `}<inlineCode parentName="p">{`npm run-script load-env`}</inlineCode>{` or `}<inlineCode parentName="p">{`yarn run load-env`}</inlineCode>{` to use the local copy of the `}<inlineCode parentName="p">{`buildpack`}</inlineCode>{` CLI.`}</p>
    <h3 {...{
      "id": "using-npx"
    }}>{`Using `}<inlineCode parentName="h3">{`npx`}</inlineCode></h3>
    <p>{`Run `}<inlineCode parentName="p">{`buildpack`}</inlineCode>{` directly using NPM's `}<inlineCode parentName="p">{`npx`}</inlineCode>{` tool, which installs packages and runs their CLIs in a single command:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npx @magento/pwa-buildpack <command>
`}</code></pre>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`You should not install the `}<inlineCode parentName="p">{`buildpack`}</inlineCode>{` command globally with `}<inlineCode parentName="p">{`yarn global add`}</inlineCode>{` or `}<inlineCode parentName="p">{`npm install --global`}</inlineCode>{`.
Individual projects should use their own versions, to guarantee expected behavior.`}</p>
    <h2 {...{
      "id": "available-subcommands"
    }}>{`Available subcommands`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`buildpack`}</inlineCode>{` CLI provides the following subcommands:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "create-custom-origin/"
        }}><inlineCode parentName="a">{`create-custom-origin`}</inlineCode></a>{` - Gets or creates a trusted SSL certificate for local PWA development.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "create-environment-file/"
        }}><inlineCode parentName="a">{`create-env-file`}</inlineCode></a>{` - Generates a new `}<inlineCode parentName="li">{`.env`}</inlineCode>{` file in the current directory.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "load-environment-file/"
        }}><inlineCode parentName="a">{`load-env`}</inlineCode></a>{` - Loads and validates the current environment.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      